import {Typography, Modal, Stack} from '@mui/material';
import {VFC} from 'react';
import {useNavigate} from 'react-router-dom';
import {BaseBox as Box} from '../components/BaseBox';
import {ArrowRightIcon} from '../images/ArrowRightIcon';
import {EditPlusIcon} from '../images/EditPlusIcon';
import {UploadIcon} from '../images/UploadIcon';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const PropertyRegistrationMethodSelectionModal: VFC<Props> = ({
  open,
  onClose,
}) => {
  const navigate = useNavigate();
  return (
    <Modal open={open} onClose={onClose} disableAutoFocus>
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '400px',
          boxShadow: 'none',
        }}>
        <Typography
          textAlign="center"
          mb="24px"
          sx={{fontSize: '20px', fontWeight: '500', lineHeight: '26px'}}>
          新規登録
        </Typography>
        <Stack spacing={1.5}>
          <Stack
            onClick={() => {
              navigate('/addProperty');
              onClose();
            }}
            sx={style}>
            <Stack spacing={1} direction="row" alignItems="center">
              <EditPlusIcon
                color="primary"
                strokeWidth={1.5}
                sx={{
                  fill: 'transparent !important',
                  width: 32,
                  height: 32,
                }}
              />
              <Typography sx={{fontSize: '16px', fontWeight: '500'}}>
                手動で入力する
              </Typography>
            </Stack>
            <ArrowRightIcon
              sx={{
                width: 20,
                height: 20,
                fill: 'transparent !important',
                stroke: '#A1A5B6',
              }}
            />
          </Stack>
          <Stack
            onClick={() => {
              navigate('/addPropertyWithOcr');
              onClose();
            }}
            sx={style}>
            <Stack spacing={1} direction="row" alignItems="center">
              <UploadIcon
                strokeColor="#31CDD3"
                sx={{
                  width: 32,
                  height: 32,
                  fill: 'transparent !important',
                  flexShrink: 0,
                }}
              />
              <Stack spacing={0.5} mr={1}>
                <Typography fontSize={16} fontWeight={500}>
                  画像から登録する
                </Typography>
                <Typography fontSize={12}>
                  書類をアップロードすることで、内容を自動で読み取って登録することができます。
                </Typography>
              </Stack>
            </Stack>
            <ArrowRightIcon
              sx={{
                width: 20,
                height: 20,
                fill: 'transparent !important',
                stroke: '#A1A5B6',
              }}
            />
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

const style = {
  py: 2,
  pl: 1.5,
  pr: 1,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  border: 1,
  borderRadius: 1,
  borderColor: 'flikGray.-20',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'flikPrimary.-50',
  },
  transition: 'background 0.2s ease-out',
};
